/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import Dates from "utils/Dates";
import {Reservation} from "types/entities/Reservation";
import {useTranslation} from "react-i18next";
import {padMinutes} from "utils/utility";
import clsx from "clsx";
import BookingLoginReservationDetailField
    from "pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/BookingLoginReservationDetailField";
import CardComponent from "pages/Front/Booking/components/CardComponent";

interface BookingLoginReservationInfoCardProps {
    reservation: Reservation | null;
    className?: string;
    hideDescription?: boolean;
}

const BookingLoginReservationInfoCard = (props: BookingLoginReservationInfoCardProps) => {
    const {t} = useTranslation();

    return (
        <CardComponent className={clsx("BookingLoginReservationInfoCard w-full  text-black", props.className)}>
            {props.reservation == null ? (
                <div
                    className={
                        "flex flex-col lg:flex-row gap-y-[7px] gap-x-[38px] justify-between md:justify-around px-[6px] md:px-[22px] py-[2px] md:py-[28px] h-full"
                    }
                >
                    <BookingLoginReservationDetailField className={"col-span-1"} label={t("Date")} name={"reservation_at"} value={null} />
                    <BookingLoginReservationDetailField className={"col-span-1"} label={t("ID")} name={"code"} value={null} />
                    <BookingLoginReservationDetailField className={"col-span-1"} label={t("Time")} name={"hour"} value={null} />
                    <BookingLoginReservationDetailField className={"col-span-1"} label={t("Persons")} name={"personen"} value={null} />
                </div>
            ) : (
                <div
                    className={
                        "flex flex-col lg:flex-row gap-y-[7px] gap-x-[38px] justify-between md:justify-around px-[6px] md:px-[22px] py-[2px] md:py-[28px] h-full"
                    }
                >
                    <BookingLoginReservationDetailField
                        className={"col-span-1"}
                        label={t("Date")}
                        name={"reservation_at"}
                        value={Dates.ymd(props.reservation.date, "DD.MM.YYYY")}
                    />
                    <BookingLoginReservationDetailField className={"col-span-1"} label={t("ID")} name={"code"} value={props.reservation.guid.toUpperCase()} />
                    <BookingLoginReservationDetailField
                        className={"col-span-1"}
                        label={t("Time")}
                        name={"hour"}
                        value={padMinutes(props.reservation.hour) + ":" + padMinutes(props.reservation.minute)}
                    />
                    <BookingLoginReservationDetailField className={"col-span-1"} label={t("Persons")} name={"personen"} value={props.reservation.persons} />
                </div>
            )}
        </CardComponent>
    );
};

export default BookingLoginReservationInfoCard;
